import selectorReducerFor, { selectorInitialState, SelectorState } from '../../redux/selector/reducerFor'
import { BasicTarget, TARGET_PREFIX, TARGET_RESOURCE_NAME } from './model'
import { ResourceTargetAction } from './actions'

export type ResourceTargetSelectorState = SelectorState<BasicTarget>

export const resourceTargetSelectorInitialState = {...selectorInitialState}

export const resourceTargetSelectorReducer = (origin?: string) => {
    const resourceTargetReducerForOrigin = selectorReducerFor<BasicTarget>(TARGET_RESOURCE_NAME, TARGET_PREFIX, origin)
    return function reducer(state: ResourceTargetSelectorState = resourceTargetSelectorInitialState, action: ResourceTargetAction)
        : ResourceTargetSelectorState {
            return {
                ...state,
                ...resourceTargetReducerForOrigin(state, action)
            }
    }
}
